import {
	requests
}from "../../../api/agent"

export default {
    addSuperiorOrg				   : (values) => requests.getWithParams("/superiorReOrgs/addSuperiorOrg", values),
    removeSuperiorOrg              : (values) => requests.getWithParams("/superiorReOrgs/removeSuperiorOrg", values),
    getPotentialOrgList            : (values) => requests.getWithParams("/superiorReOrgs/getPotentialOrgList", values),
    getSuperiorOrgsPaged           : (values) => requests.getWithParams("/superiorReOrgs/getSuperiorOrgsPaged", values),
    getSuperiorOrgsList            : (values) => requests.getWithParams("/superiorReOrgs/getSuperiorOrgsList", values)
}
